import React from "react";
import { crudAll, ResourceDescriptor } from "./common";
import { default as MUIPasswordField, PasswordFieldProps } from "../components/PasswordField";

import { Link } from "react-router-dom";
import DisabledDeleteResourceButton from "../components/DisabledDeleteResourceButton";
import { FormattedMessage } from "react-intl";

const user: ResourceDescriptor = {
    url: "users",
    orders: {
        create: ["email", "password", "retype_password", "given_name", "family_name", "gender", "birthdate", "locale"],
        list: ["id", "aliases", "name", "birthdate", "controlHeaderCell"],
    },
    listParamPostProcess: (params) => {
        let filter = {
            operator: "!=",
            column: "password",
            value: null,
        };
        if (Object.keys(params.filters).length === 0 && params.filters.constructor === Object) params.filters = filter;
        else {
            params.filters = {
                operator: "and",
                value: [filter, params.filters],
            };
        }
    },
    crudActions: crudAll,
    listDefaults: {
        sort: {
            name: "id",
            direction: "asc",
        },
        limit: 20,
        offset: 0,
    },
    renderers: {
        read: {
            gender: (val, row) => {
                return <FormattedMessage id={`user.${val}` || ""} />;
            },
        },
        list: {
            id: (val, row) => {
                return <Link to={`/users/read/${row.id}`}>{`#${row.id}`}</Link>;
            },
            aliases: (val, row) => {
                let items = [];
                for (let i of val) items.push(i.name);
                return items.join(", ");
            },
            controlHeaderCell: (val, row) => {
                return (
                    <DisabledDeleteResourceButton
                        resourceName="user"
                        id={row.id}
                        userId={row.id}
                        translationKey="deleting_own_user_is_forbidden"
                    />
                );
            },
        },
    },
    muiRenderers: {
        create: {
            password: React.forwardRef<HTMLDivElement, PasswordFieldProps>((props, ref) => (
                <MUIPasswordField {...props} autoComplete="new-password" ref={ref} />
            )),
            retype_password: React.forwardRef<HTMLDivElement, PasswordFieldProps>((props, ref) => (
                <MUIPasswordField {...props} autoComplete="new-password" ref={ref} />
            )),
        },
    },
    identifiers: ["name"],
    resourceSchemaPostProcessor: (schema) => {
        schema["retype_password"] = {
            default: null,
            required: false,
            type: {
                name: "String",
            },
            name: "retype_password",
            validators: [
                {
                    params: { passwordFieldName: "password" },
                    name: "passwordMatch",
                    key: "passwordMatch_error",
                },
            ],
        };
    },
    expand: {
        list: ["aliases"],
        read: [
            "user_sub.user_infos.client",
            "user_sub.user_grants.role.role_contexts",
            "user_sub.user_grants.user_contexts.context",
            "user_sub.user_grants.role.client",
            "emails.tokens",
        ],
    },
};

export default user;
